import { object, string, array } from '@gogame/schemas';

import { CONDITIONS } from './Conditions';
import { EXTRA_METRICS } from './ExtraMetrics';
import { NOTIFICATIONS } from './Notifications';

export const smartRuleValidationSchema = object({
  [CONDITIONS]: array(),
  [NOTIFICATIONS]: string().required('Email recipients level is required'),
  [EXTRA_METRICS]: array(string()),
});
